<template>
  <b-modal
    id="modal-meta-capi-payload"
    v-model="showModal"
    hide-footer
    hide-header
    centered
    dialog-class="custom-modal-capi"
  >
    <div >
      <!-- Header -->
      <div class="flex items-center justify-between pb-1 mb-1.5 border-b border-gray-100">
        <div>
          <h4 class="text-base font-bold text-[#333333] mb-0.5">
            Detail {{ eventName }}
          </h4>
          <div class="flex items-center gap-1.5 text-xs text-[#828282]">
            <span>
              Status:
              <strong :class="isSuccess ? 'text-green-600' : 'text-danger'">
                {{ isSuccess ? 'Dikirim' : 'Gagal' }}
              </strong>
            </span>
            <span>&bull;</span>
            <span>
              Response:
              <strong :class="isSuccess ? 'text-green-600' : 'text-danger'">
                {{ httpCode || (isSuccess ? 200 : 400) }}
              </strong>
            </span>
            <span v-if="eventTime">&bull;</span>
            <span v-if="eventTime">
              {{ formatTime(eventTime) }}
            </span>
          </div>
        </div>
        <button
          type="button"
          class="p-0 border-0 bg-transparent text-gray-400 hover:text-gray-600 cursor-pointer focus:outline-none"
          @click="showModal = false"
        >
          <feather-icon
            icon="XIcon"
            size="18"
          />
        </button>
      </div>

      <!-- Section 1: Payload yang dikirim ke Meta -->
      <div class="mb-1.5">
        <div class="flex items-center justify-between mb-0.5">
          <label class="text-xs font-semibold text-[#333333] mb-0">
            Payload yang dikirim ke Meta
          </label>
          <button
            type="button"
            class="text-xs text-[#F97316] hover:underline p-0 border-0 bg-transparent cursor-pointer flex items-center gap-0.5 focus:outline-none"
            @click="copyToClipboard(requestJsonString, 'Request')"
          >
            <feather-icon
              icon="CopyIcon"
              size="12"
            />
            <span>{{ copiedType === 'Request' ? 'Tersalin' : 'Salin' }}</span>
          </button>
        </div>
        <pre class="bg-[#F8F9FA] text-[#333333] border border-gray-200 p-2 rounded-lg text-xs overflow-x-auto max-h-56 leading-relaxed font-mono mb-0"><code>{{ requestJsonString }}</code></pre>
      </div>

      <!-- Section 2: Response Meta -->
      <div>
        <div class="flex items-center justify-between mb-0.5">
          <label class="text-xs font-semibold text-[#333333] mb-0">
            Response Meta
          </label>
          <button
            type="button"
            class="text-xs text-[#F97316] hover:underline p-0 border-0 bg-transparent cursor-pointer flex items-center gap-0.5 focus:outline-none"
            @click="copyToClipboard(responseJsonString, 'Response')"
          >
            <feather-icon
              icon="CopyIcon"
              size="12"
            />
            <span>{{ copiedType === 'Response' ? 'Tersalin' : 'Salin' }}</span>
          </button>
        </div>
        <pre class="bg-[#F8F9FA] text-[#333333] border border-gray-200 p-2 rounded-lg text-xs overflow-x-auto max-h-36 leading-relaxed font-mono mb-0"><code>{{ responseJsonString }}</code></pre>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'ModalMetaCapiPayload',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    payloadData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      copiedType: '',
    }
  },
  computed: {
    showModal: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
    // Log list mengirim { event, event_date, response_status_code },
    // sedangkan payload mentah memakai { event_name, created_at, http_code }.
    eventName() {
      return this.payloadData.event_name || this.payloadData.event || 'Event'
    },
    eventTime() {
      return this.payloadData.created_at || this.payloadData.event_date || ''
    },
    httpCode() {
      return this.payloadData.http_code || this.payloadData.response_status_code || ''
    },
    isSuccess() {
      const status = String(this.payloadData.status || '').toLowerCase()
      const code = Number(this.payloadData.http_code || this.payloadData.response_status_code)
      return status === 'success' || (code >= 200 && code < 300)
    },
    requestJsonString() {
      const payload = this.payloadData.request_payload || this.payloadData.payload || {}
      if (typeof payload === 'string') {
        try {
          return JSON.stringify(JSON.parse(payload), null, 2)
        } catch {
          return payload
        }
      }
      return JSON.stringify(payload, null, 2)
    },
    responseJsonString() {
      const response = this.payloadData.response_body || this.payloadData.response_payload || this.payloadData.response || {}
      if (typeof response === 'string') {
        try {
          return JSON.stringify(JSON.parse(response), null, 2)
        } catch {
          return response
        }
      }
      return JSON.stringify(response, null, 2)
    },
  },
  methods: {
    formatTime(dateStr) {
      if (!dateStr) return '-'
      try {
        const d = new Date(dateStr)
        return d.toLocaleTimeString('id-ID', { hour: '2-digit', minute: '2-digit', second: '2-digit' })
      } catch {
        return dateStr
      }
    },
    async copyToClipboard(text, type) {
      try {
        await navigator.clipboard.writeText(text)
        this.copiedType = type
        setTimeout(() => {
          this.copiedType = ''
        }, 2000)
      } catch {
        // Fallback copy
        const el = document.createElement('textarea')
        el.value = text
        document.body.appendChild(el)
        el.select()
        document.execCommand('copy')
        document.body.removeChild(el)
        this.copiedType = type
        setTimeout(() => {
          this.copiedType = ''
        }, 2000)
      }
    },
  },
}
</script>

<style>
.custom-modal-capi {
  max-width: 540px;
  width: 100%;
}
</style>
